import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingGrokAiVideoGeneratorConfig } from '@/data/landingConfig/landingGrokAiVideoGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_GrokAiVideoGenerator } from './schemaObject';

interface Props {}
const GrokAiVideoGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_GrokAiVideoGenerator} />
			<LandingTemplate
				data={landingGrokAiVideoGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelTextToVideoV2()}
			/>
		</>
	);
};

export default GrokAiVideoGenerator;
